import React from 'react';
import '../../../styles/pageStyles/applicationListing/advanceFilter.css'
import { useState, useEffect, useRef } from 'react';
import config from "../../../config/Config";
import "react-datepicker/dist/react-datepicker.css";
import { getYear, getMonth } from "date-fns";
import ChevronLeftOutlined from "@mui/icons-material/ChevronLeftOutlined";
import ChevronRightOutlined from "@mui/icons-material/ChevronRightOutlined";
import { parse, isValid, format } from "date-fns";
import CustomDateInput from '../../common/CustomDateInput';
import { Button, CircularProgress } from '@mui/material';
import CustomModal from '../../common/modals/CustomModal';

const AdvancedFilterPanel = ({ props }) => {
  const {
    showFilters,
    pendingFilters,
    setPendingFilters,
    globalSearch,
    setGlobalSearch,
    inputText,
    setInputText,
    handlePendingFilterChange,
    updatePendingFilter,
    applyFilters,
    clearAllFilters,
    cxSpecialists,
    originators,
    statuses,
    tableData,
    masterCheck,
    onDeleteSelected,
    dateError,
    setDateError,
    propertyTypes,
    handleExcelExport,
    executeEmailExport,
    filtersAppliedOnce,
    setFiltersAppliedOnce,
    setSelectedFilters,
    setSelectedInlineFilters,
  } = props;

  // Stores list of states fetched from backend
  const [states, setStates] = useState([]);

  // Email state 
  const [exportModalOpen, setexportModalOpen] = useState(false);
  const [isEmailExportLoading, setIsEmailExportLoading] = useState(false);

  //handler for export
  const handleExportChoice = () => {
    setexportModalOpen(true);
  };

  const exportModalClose = () => {
    setexportModalOpen(false);
  };

  /**
   * - If "To" date is present, "From" must exist
   * - If "From" date is present, "To" must exist
   */
  const validateDateRangeForApply = () => {
    const hasFrom = !!pendingFilters.created_date_from;
    const hasTo = !!pendingFilters.created_date_to;

    if (!hasFrom && hasTo) {
      setDateError({ field: "from", message: "Please enter the start date." });
      return false;
    }
    if (hasFrom && !hasTo) {
      setDateError({ field: "to", message: "Please enter the end date." });
      return false;
    }
    setDateError(null);
    return true;
  };

  /**
   * Triggered when user clicks "Apply Filters"
   * - First validates date range
   * - If valid, calls parent applyFilters()
   */
  const handleApplyClick = () => {
    if (!validateDateRangeForApply()) {
      return;
    }
    setDateError(null);
    applyFilters();
  };

  // Static Property Type options (Hardcoded)
  const PROPERTY_TYPE_OPTIONS = [
    { id: 2, label: "Single Family Residence" },
    { id: 5, label: "Duplex" },
    { id: 4, label: "Townhouse" },
    { id: 3, label: "Condominium" },
    { id: 6, label: "Manufactured Home - Not Supported" },
  ];

  /**
   * Fetch States from backend on component mount
   */
  useEffect(() => {
    var tokenStr = localStorage.getItem("access_token");

    fetch(`${config.baseUrl}get-states/`, {
      headers: { Authorization: `Bearer ${tokenStr}` },
    })
      .then((res) => res.json())
      .then((data) => setStates(data))
      .catch((err) => console.log(err));
  }, []);

  /**
   * Reset search input text when all filters are cleared
   * This keeps UI in sync with filter state
   */
  useEffect(() => {
    const hasAnyFilter = Object.values(pendingFilters).some(
      (v) =>
        v !== undefined &&
        v !== null &&
        v !== "" &&
        !(Array.isArray(v) && v.length === 0),
    );

    // If no filters exist, reset all search inputs
    if (!hasAnyFilter) {
      setInputText({
        property_types: "",
        cx_specialist: "",
        app_status: "",
        originator: "",
        state: "",
      });
    }
  }, [pendingFilters]);

  function ExportModal() {
    return (
      <div>
        <div
          className="d-flex justify-center"
          style={{ columnGap: "25px", marginTop: "10px" }}
        >
          <Button
            className="app-primary-btn"
            variant="contained"
            onClick={() => {
              exportModalClose();
              handleExcelExport();
            }}
          >
            Download Excel
          </Button>
          <Button
            className="app-primary-btn"
            variant="contained"
            onClick={async () => {
              await executeEmailExport();
              exportModalClose();
            }}
            disabled={isEmailExportLoading}
          >
            {isEmailExportLoading ? (
              <CircularProgress size={18} sx={{ color: "white" }} />
            ) : (
              "Email Excel Report"
            )}
          </Button>
        </div>
      </div>
    );
  }

  /**
   * Reusable renderer for multi-select filter with search + checkbox
   * This function:
   * - Filters options based on search input
   * - Displays checkbox list
   * - Updates filter state on selection
   */
  const renderMultiSelectFilter = (
    label,
    filterKey,
    options,
    getOptionId,
    getOptionLabel,
  ) => (
    <div className="filter-item">
      <div className="filter-label-row">
        <span>{label}</span>
      </div>

      {/* Search input inside filter */}
      <input
        className="filter-input"
        type="text"
        placeholder={`Search ${label}`}
        style={{ fontFamily: "proxima-regular" }}
        value={inputText[filterKey] || ""}
        onChange={(e) =>
          setInputText((prev) => ({ ...prev, [filterKey]: e.target.value }))
        }
      />

      {/* Options list with scroll */}
      <div
        className="options-container"
        style={{
          maxHeight: "150px",
          overflowY: "auto",
          border: "1px solid #ddd",
          borderRadius: "4px",
        }}
      >
        {options
          .filter(
            (item) =>
              !inputText[filterKey] ||
              getOptionLabel(item)
                .toLowerCase()
                .includes(inputText[filterKey].toLowerCase()),
          )
          .map((item) => {
            const id = getOptionId(item);
            const isChecked = pendingFilters[filterKey]?.includes(id);

            return (
              <label
                className="option-label"
                key={id}
                style={{ display: "block", padding: "5px", fontSize: "14px" }}
              >
                <input
                  type="checkbox"
                  checked={!!isChecked}
                  onChange={() => {
                    // If already selected → remove it
                    if (isChecked) {
                      updatePendingFilter(filterKey, id);

                      // If filters already applied once, sync selectedFilters
                      if (filtersAppliedOnce) {
                        setSelectedFilters((prev) => ({
                          ...prev,
                          [filterKey]: (prev[filterKey] || []).filter(
                            (v) => v !== id,
                          ),
                        }));
                      }
                    } else {
                      // Add new selection
                      updatePendingFilter(filterKey, id);
                    }
                    setInputText((prev) => ({ ...prev, [filterKey]: "" }));
                  }}
                />
                {getOptionLabel(item)}
              </label>
            );
          })}
      </div>
    </div>
  );


  return (
    <div className="filters-container open">
      {/* Global search input */}
      <div className="global-search-row">
        <input
          type="text"
          className="global-search-input"
          placeholder="Search: Application ID, Borrower Name, Address"
          value={globalSearch}
          onChange={(e) => setGlobalSearch(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "15px",
            border: "1px solid #ddd",
            borderRadius: "4px",
          }}
        />

        {/* Action buttons */}
        <div
          className="apply-filter-btn-wrapper"
          style={{ display: "flex", gap: "10px", marginTop: "15px" }}
        >
          <button className="apply-filter-btn" onClick={handleApplyClick}>
            Apply Filters
          </button>

          <button className="export-button" onClick={handleExportChoice}>
            Export With Filters
          </button>
        </div>
      </div>

      {/* Filters section */}
      {showFilters &&(
      <div
        className="filter-bar slide-down"
        style={{ display: "flex", justifyContent:"space-around", gap: "15px", marginTop: "15px" }}
      >
        {/* Property Type */}
        {renderMultiSelectFilter(
          "Property Type",
          "property_types",
          PROPERTY_TYPE_OPTIONS,
          (pt) => pt.id,
          (pt) => pt.label,
        )}

        {/* CX Specialist */}
        {renderMultiSelectFilter(
          "CX Specialist",
          "cx_specialist",
          cxSpecialists || [],
          (s) => s.id,
          (s) => s.get_user_full_name,
        )}

        {/* Status */}
        {renderMultiSelectFilter(
          "Status",
          "app_status",
          statuses || [],
          (s) => s.application_status_id,
          (s) => s.application_status,
        )}

        {/* Originator */}
        {renderMultiSelectFilter(
          "Originator",
          "originator",
          originators || [],
          (o) => o.partner_id,
          (o) => o.partner_name,
        )}

        {/* State */}
        {renderMultiSelectFilter(
          "State",
          "state",
          states || [],
          (s) => s.state_id,
          (s) => `${s.state_name} (${s.state_code})`,
        )}
      </div>
      )}
      
      <CustomModal
        open={exportModalOpen}
        header={"Export Applications"}
        body={ExportModal()}
        handleClose={exportModalClose}
      />
    </div>
  );
};;

export default AdvancedFilterPanel;